module.exports = __webpack_public_path__ + "static/logo-dark-ef44de9c720744e94285975be1c1dd7b.svg";